var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartyDecoration = function SvgPartyDecoration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m.75 1.75 22.5 3.587M2.293 2l1.014 4.153a1.066 1.066 0 0 0 1.873.3l2.256-3.637m2.058.328L10.508 7.3a1.066 1.066 0 0 0 1.872.3l2.257-3.636m2.057.328 1.014 4.157a1.066 1.066 0 0 0 1.873.3l2.256-3.636M.759 19.793l22.491-8.695M2.3 19.2l3.143 3.266a1.13 1.13 0 0 0 1.874-.725l.129-4.531m2.061-.799 3.143 3.266a1.13 1.13 0 0 0 1.874-.724l.129-4.531m2.058-.796 3.144 3.266a1.129 1.129 0 0 0 1.873-.725l.129-4.531"
  })));
};
export default SvgPartyDecoration;